// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";
import "./assets/css/element-custom.css";
import "./assets/theme/index.css";
import "./assets/iconfont/iconfont.css";
import store from "./store/index.js";
import locale from "../node_modules/element-ui/lib/locale/lang/en";

Vue.use(ElementUI, { locale });

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
  mounted() {
    window.vue = this;
  },
  methods: {
    updateAdress(address) {
      console.log(address);
    },
  },
});



// WEBPACK FOOTER //
// ./src/main.js